import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import face from "../../Assets/about.png";
// import Socials from "../../components/Footer";

function About() {
  return (
    <Container fluid className="about-section">
      <Container style={{ width: "90%" }}>
        <Row style={{ justifyContent: "center", paddingTop: "3vh" }}>
          <Col
            sm={12}
            md={5}
            style={{
              justifyContent: "center",
            }}
          >
            <h1 style={{ fontSize: "1em", fontWeight: 300, paddingBottom: "20px" }}>
              I am a MSc + PhD student at the University of Toronto working on problems of machine learning 
              trustworthiness in the areas of security and privacy. My fascination with the intersection of 
              computer science and visual arts means I'm excited by different creative opportunities-
              whether it's working on research problems, building products, in the kitchen, or painting 
              on a canvas.<br />
              <br/>
              I've worked on QA and entity linking for 3 years at Apple, in addition to TTS and CV/graphics problems 
              in previous roles.
              Prior, I was researching adversarial machine learning at SAND Lab (advised by{" "} 
              <a id="link" href="http://people.cs.uchicago.edu/~ravenben/">Ben Zhao</a>).<br /><br />
              
              As a Chinese-Canadian <a id="link" href="https://en.wikipedia.org/wiki/Third_culture_kid">third culture kid</a>,
              I cook "fusion", love travelling, and am bilingual but sometimes forget both languages.
              I also love to: <br /><br/>
              <ul style={{ listStylePosition: "inside" }}>
                <li>
                  host dinner parties, <Link to="/design">design around food</Link>
                </li>
                <li>
                  oil paint, photograph
                </li>
                <li>
                  hang out with my pup Harper
                </li>
              </ul>

            </h1>
          </Col>
          <Col
            sm={12}
            md={4}
            style={{}}
            className="about-img"
          >
            <img src={face} alt="about" className="img-fluid" style={{ maxHeight: "25em", paddingLeft: "20%" }} />
          </Col>
        </Row>

      </Container>
    </Container>
  );
}

export default About;
